import { ValueFormatterParams } from "ag-grid-enterprise";

export function numberFormatter(params: ValueFormatterParams, decimals = 2) {
  if (params.value !== null) {
    return Number(params.value).toFixed(decimals);
  }
  return params.value;
}
